import React, { useState } from 'react';
import { Badge, Button, Card, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import { showToast, toastMessages } from '../../../utils/toast';

const ApiPartnerTopUpRequest = () => {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    amount: '',
    paymentMethod: '',
    remarks: ''
  });
  const [errors, setErrors] = useState({});

  const requestHistory = [
    {
      id: 'TPU-9051',
      date: '2025-11-04 11:20 AM',
      amount: '500000',
      requestTo: 'Operations Desk',
      paymentMethod: 'IMPS',
      status: 'Approved',
      remarks: 'IMPS Ref: 791245'
    },
    {
      id: 'TPU-9047',
      date: '2025-11-02 04:10 PM',
      amount: '350000',
      requestTo: 'Payments Team',
      paymentMethod: 'NEFT',
      status: 'Pending',
      remarks: 'Awaiting settlement window confirmation'
    },
    {
      id: 'TPU-9038',
      date: '2025-10-28 01:05 PM',
      amount: '200000',
      requestTo: 'Operations Desk',
      paymentMethod: 'RTGS',
      status: 'Approved',
      remarks: 'RTGS Ref: 662809'
    },
    {
      id: 'TPU-9024',
      date: '2025-10-18 10:30 AM',
      amount: '150000',
      requestTo: 'Operations Desk',
      paymentMethod: 'IMPS',
      status: 'Rejected',
      remarks: 'Mismatch in supporting documents'
    },
    {
      id: 'TPU-9018',
      date: '2025-10-10 06:45 PM',
      amount: '250000',
      requestTo: 'Payments Team',
      paymentMethod: 'NEFT',
      status: 'Approved',
      remarks: 'NEFT Ref: 543201'
    }
  ];

  const handleOpenModal = () => {
    setErrors({});
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      amount: '',
      paymentMethod: '',
      remarks: ''
    });
    setErrors({});
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    setErrors((prev) => {
      if (!prev[name]) {
        return prev;
      }
      const updatedErrors = { ...prev };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = {};

    if (!formData.amount) {
      newErrors.amount = 'Amount is required.';
    }

    if (!formData.paymentMethod) {
      newErrors.paymentMethod = 'Payment method is required.';
    }

    if (!formData.remarks) {
      newErrors.remarks = 'Remarks are required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      showToast.error(toastMessages.validationError);
      return;
    }

    showToast.success(toastMessages.topUpSuccess);
    handleCloseModal();
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Approved':
        return 'success';
      case 'Pending':
        return 'warning';
      case 'Rejected':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  return (
    <Container fluid className="api-partner-topup-page p-4">
      <div className="page-header mb-4 d-flex justify-content-between align-items-center">
        <div>
          <h2 className="mb-1" style={{ fontSize: '24px', fontWeight: 600, color: '#2c2268' }}>
            <i className="bi bi-arrow-repeat me-2"></i>
            Top-up Request
          </h2>
        </div>
        <Button
          onClick={handleOpenModal}
          style={{
            backgroundColor: '#1e1850',
            border: 'none',
            padding: '10px 24px',
            borderRadius: '6px',
            fontWeight: 600,
            fontSize: '15px',
            boxShadow: '0 4px 6px rgba(30, 24, 80, 0.3)'
          }}
        >
          <i className="bi bi-plus-circle me-2"></i>
          New Request
        </Button>
      </div>

      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                <i className="bi bi-clock-history me-2"></i>
                Request History
              </h5>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Request ID
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Date
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Amount
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Request To
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Payment Method
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Status
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Remarks
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestHistory.map((request, index) => (
                      <tr key={request.id} style={{ transition: 'background-color 0.2s' }}>
                        <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                          {request.id}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.date}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#333', fontSize: '13px', fontWeight: 600 }}>
                          ₹{request.amount}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.requestTo}
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.paymentMethod}
                        </td>
                        <td style={{ padding: '12px 16px' }}>
                          <Badge
                            bg={getStatusColor(request.status)}
                            style={{
                              fontSize: '11px',
                              padding: '4px 10px',
                              fontWeight: 500
                            }}
                          >
                            {request.status}
                          </Badge>
                        </td>
                        <td style={{ padding: '12px 16px', color: '#666', fontSize: '13px' }}>
                          {request.remarks}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton style={{ borderBottom: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Modal.Title style={{ fontSize: '20px', fontWeight: 600, color: '#333' }}>
            Top-up Request
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '24px' }}>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                Amount <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                name="amount"
                placeholder="Enter Amount"
                value={formData.amount}
                onChange={handleInputChange}
                style={{
                  padding: '10px 14px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
                isInvalid={!!errors.amount}
              />
              <Form.Control.Feedback type="invalid">{errors.amount}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                Payment Method <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleInputChange}
                style={{
                  padding: '10px 14px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
                isInvalid={!!errors.paymentMethod}
              >
                <option value="" disabled hidden>
                  Select payment method
                </option>
                <option value="IMPS">IMPS</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
                <option value="UPI">UPI</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">{errors.paymentMethod}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: 600, fontSize: '14px', color: '#333' }}>
                Remarks <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="remarks"
                placeholder="Remarks / Bank Ref No."
                value={formData.remarks}
                onChange={handleInputChange}
                style={{
                  padding: '10px 14px',
                  fontSize: '14px',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}
                isInvalid={!!errors.remarks}
              />
              <Form.Control.Feedback type="invalid">{errors.remarks}</Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ borderTop: '1px solid #dee2e6', padding: '16px 24px' }}>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
            style={{
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 500,
              borderRadius: '4px'
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            className="send-button"
            style={{
              backgroundColor: 'transparent',
              border: '2px solid #0d6efd',
              color: '#0d6efd',
              padding: '8px 20px',
              fontSize: '14px',
              fontWeight: 600,
              borderRadius: '4px',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#0d6efd';
              e.currentTarget.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#0d6efd';
            }}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx="true">{`
        .api-partner-topup-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .modal-content {
          border-radius: 8px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .modal-header .btn-close {
          padding: 0.5rem;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }
        }
      `}</style>
    </Container>
  );
};

export default ApiPartnerTopUpRequest;
